import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";

const AmbientLightComponent = ({ color, intensity }) => {
    const light = useRef();

    useFrame(() => {
        if (light.current) {
            light.current.color.set(color);
            light.current.intensity = intensity;
        }
    });

    return <ambientLight ref={light} />;
};

export default AmbientLightComponent;
